import React, { useState, useEffect, useRef } from "react";
import { Prompt } from "react-router";
import { useHistory, useParams } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  message,
  Space,
  Row,
  Col,
  Menu,
  Dropdown,
  Spin,
} from "antd";
import {
  getItemUnitById,
  editItemUnit,
  getNewItemUnitCode,
} from "../../../services/Items/itemUnitService";
import { RetweetOutlined } from "@ant-design/icons";
import _t from "../../../languages/translate";

const ItemUnitForm = ({ onNewUnit }) => {
  const IX_Code = useRef(null);
  const IX_Name = useRef(null);
  const [loading] = useState(false);
  const [loadData, setLoadData] = useState(true);
  const [form] = Form.useForm();
  let history = useHistory();
  let { id } = useParams();
  const [isGoBack, setIsGoBack] = useState(true);
  const [companyId] = useState(window.localStorage.getItem("comId"));

  const codeGenerator = async () => {
    const { data: newData } = await getNewItemUnitCode();
    form.setFieldsValue({ code: newData.data });
    IX_Name.current.focus();
    setLoadData(false);
  };

  useEffect(() => {
    async function fetchData() {
      if (id === "new" || typeof onNewUnit === "function") {
        return await codeGenerator();
      } else {
        try {
          const { data } = await getItemUnitById(id);
          form.setFieldsValue({
            id: data.data.Id,
            code: data.data.code,
            name: data.data.name,
            companyId: data.data.companyId,
          });
          IX_Name.current.focus();
          setLoadData(false);
        } catch (error) {
          if (error.response) {
            message.error(
              error.response.data?.message || _t("msgUnknownError"),
              3
            );
            setLoadData(false);
          } else if (error.request) {
            message.error(_t("msgServerDisconnected"), 3);
            setLoadData(false);
          } else {
            message.error(_t("msgUnknownError"), 3);
            setLoadData(false);
          }
        }
      }
    }
    fetchData();
  }, [id, history, setLoadData]);

  //******************************// //*******************// Back //*******************// //******************************//

  const menu = (
    <Menu>
      <Menu.Item onClick={() => setIsGoBack(true)}>
        {_t("strLeaveThePage")}
      </Menu.Item>
      <Menu.Item onClick={() => setIsGoBack(false)}>
        {_t("strStayInPage")}
      </Menu.Item>
    </Menu>
  );

  const goBack = () => {
    setProChange(false);
    if (isGoBack) {
      history.goBack();
    } else {
      form.resetFields();
      history.replace({ ...history.location, pathname: "/unit/new" });
      codeGenerator();
      IX_Name.current.focus();
    }
  };

  //******************************// //*******************// Save //*******************// //******************************//

  const onFinish = async (values) => {
    if (typeof onNewUnit === "function") {
      values.id = "new";
    } else {
      values.id = id;
    }
    values.companyId = companyId;
    try {
      const data = await editItemUnit(values);
      message.success(data.data.message, 3);
      if (typeof onNewUnit === "function") {
        onNewUnit(data);
      } else {
        goBack();
      }
    } catch (error) {
      if (error.response) {
        if (error.response.data.ex.includes("IX_Code")) {
          IX_Code.current.focus();
          message.error(
            error.response.data?.message || _t("msgUnknownError"),
            3
          );
          setLoadData(false);
        } else if (error.response.data.ex.includes("IX_Name")) {
          IX_Name.current.focus();
          message.error(
            error.response.data?.message || _t("msgUnknownError"),
            3
          );
          setLoadData(false);
        } else {
          message.error(
            error.response.data?.message || _t("msgUnknownError"),
            3
          );
          setLoadData(false);
        }
      } else if (error.request) {
        message.error(_t("msgServerDisconnected"), 3);
        setLoadData(false);
      } else {
        message.error(_t("msgUnknownError"), 3);
        setLoadData(false);
      }
    }
  };

  //******************************// //*******************// Form Code //*******************// //******************************//

  const [proChange, setProChange] = useState(false);
  const promptForm = () => {
    setProChange(true);
  };

  //******************************// //*******************// Form //*******************// //******************************//

  return (
    <React.Fragment>
      <Prompt when={proChange} message={_t("strUnsavedChanges")} />

      <div className="bg">
        <Spin spinning={loadData} tip={_t("strLoading")}>
          <Form
            form={form}
            name="itemUnitform"
            onFinish={onFinish}
            layout="vertical"
          >
            <Row gutter={12}>
              <Col xs={24} md={24}>
                <Form.Item
                  name="code"
                  label={_t("strCode")}
                  rules={[
                    {
                      required: true,
                      message: `${_t("strIsRequired")}`,
                    },
                    { min: 1, message: `${_t("strFrom3-200")}` },
                    { max: 200, message: `${_t("strFrom3-200")}` },
                  ]}
                >
                  <Input
                    placeholder={_t("strCode")}
                    autoComplete="off"
                    maxLength={200}
                    onChange={promptForm}
                    ref={IX_Code}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={24}>
                <Form.Item
                  name="name"
                  label={_t("strName")}
                  rules={[
                    { required: true, message: `${_t("strIsRequired")}` },
                    { min: 1, message: `${_t("strFrom3-200")}` },
                    { max: 200, message: `${_t("strFrom3-200")}` },
                  ]}
                >
                  <Input
                    placeholder={_t("strName")}
                    maxLength={200}
                    autoComplete="off"
                    onChange={promptForm}
                    ref={IX_Name}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Space size="large">
                <Button type="primary" htmlType="submit" disabled={loading}>
                  {_t("strSave")}
                </Button>
                <Dropdown.Button
                  hidden={typeof onNewStore === "function"}
                  overlay={menu}
                  onClick={() => history.goBack()}
                >
                  {" "}
                  {_t("strBack")}
                </Dropdown.Button>
                {isGoBack ? (
                  <i />
                ) : (
                  <RetweetOutlined style={{ fontSize: 21, marginTop: 5 }} />
                )}
              </Space>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    </React.Fragment>
  );
};

export default ItemUnitForm;
